import { useMemo } from "react";

export interface EngagementBreakdownItem {
  clicked: number;
  delivered: number;
  label: string;
  percentage: number;
}

interface EngagementBreakdownSummary {
  total: number;
  sortedBreakdown: EngagementBreakdownItem[];
}

export const useEngagementBreakdownSummary = (
  breakdown: EngagementBreakdownItem[],
): EngagementBreakdownSummary =>
  useMemo(() => {
    const [firstItem] = breakdown;

    if (firstItem === undefined) throw new Error("Engagement breakdown data cannot be empty");

    return {
      total: breakdown.reduce((total, item) => total + item.percentage, 0),
      sortedBreakdown: breakdown.toSorted((a, b) => {
        const percentageSort = b.percentage - a.percentage;
        if (percentageSort !== 0) return percentageSort;

        return a.percentage === 0 ? a.delivered - b.delivered : b.delivered - a.delivered;
      }),
    };
  }, [breakdown]);
